import type { ColumnTypeFn } from "../types";

export const saveHtmlType: ColumnTypeFn = (value) => {
  if (typeof value === "object" && value !== null && value.html !== undefined) {
    return value.html
      ? <span dangerouslySetInnerHTML={{ __html: value.html }} />
      : <span className="text-muted">-</span>;
  }
  if (typeof value === "object" && value !== null && value.str !== undefined) {
    return <>{value.str}</>;
  }
  return <>{String(value)}</>;
};
